<template>
    <div v-if="displayActions && bookingMethod != 'AIRBNB'">
        <add-item-button
            title="Add day"
            v-if="isAddDay && !isCancelled"
            size="xs"
            v-b-modal="addDayModalId"
        />
        <remove-item-button
            title="Remove day"
            size="xs"
            v-if="isRemoveDay && !isCancelled"
            v-b-modal="removeDayModalId"
        />                
        <modal :id="addDayModalId" title="Confirm" ok-title="Confirm" @ok="addDay" :static="true"
            >Are you sure you want to add one day to the reservation?</modal
        >
        <modal :id="removeDayModalId" title="Confirm" ok-title="Confirm" @ok="removeDay" :static="true"
            >Are you sure you want to remove one day from the reservation?</modal
        >
    </div>
</template>

<script>
    import Modal from '../../../generic/modal/modal.vue';
    import AddItemButton from '../../../common/reservation-add-item-button.vue';
    import RemoveItemButton from '../../../common/reservation-remove-item-button.vue';
    

    export default {
        components: {
            Modal,
            AddItemButton,
            RemoveItemButton
        },
        // inject: ['addRemoveDay'],
        created() {
            this.addDayModalId = `modal-add-day-${this.params.data.pos}`;
            this.removeDayModalId = `modal-remove-day-${this.params.data.pos}`;
        },
        beforeMount() {
            this.displayActions = this.params.data.type == 'DAY';
            this.isAddDay = this.params.data.add_day;
            this.isRemoveDay = this.params.data.remove_day;
            this.isStartDate = this.params.data.is_start_date;
            this.isEndDate = this.params.data.is_end_date;
            this.bookingMethod = this.params.bookingMethod;
            this.isCancelled = this.params.isCancelled || false;
        },
        data() {
            return {
                displayActions: false,
            };
        },
        methods: {
            async addDay() {
                this.params.addRemoveDay('ADD', this.isStartDate, this.isEndDate, false);
            },
            async removeDay() {
                this.params.addRemoveDay('REMOVE', this.isStartDate, this.isEndDate, false);
            },
        },
    };
</script>

<style lang="scss" scoped></style>
